export default "__VITE_ASSET__DzIluHRR__"